import { Goal } from './goal';

export const GOALS: Goal[] = [
  {
    title: 'No poverty',
    icon: 'fa fa-users',
    image: 'http://spring.myrberginnovation.se/assets/img/development-goal-1.png',
    category: '',
    today: '',
    tomorrow: '',
    next: '',
    partner: false,
    partnerName: ''
  }, {
    title: 'Zero hunger',
    icon: 'fa fa-coffee',
    image: 'http://spring.myrberginnovation.se/assets/img/development-goal-2.png',
    category: '',
    today: '',
    tomorrow: '',
    next: '',
    partner: false,
    partnerName: ''
  }, {
    title: 'Good health and well-being',
    icon: 'fa fa-heart',
    image: 'http://spring.myrberginnovation.se/assets/img/development-goal-3.png',
    category: '',
    today: '',
    tomorrow: '',
    next: '',
    partner: false,
    partnerName: ''
  }, {
    title: 'Quality education',
    icon: 'fa fa-graduation-cap',
    image: 'http://spring.myrberginnovation.se/assets/img/development-goal-4.png',
    category: '',
    today: '',
    tomorrow: '',
    next: '',
    partner: false,
    partnerName: ''
  }, {
    title: 'Gender equality',
    icon: 'fa fa-transgender',
    image: 'http://spring.myrberginnovation.se/assets/img/development-goal-5.png',
    category: '',
    today: '',
    tomorrow: '',
    next: '',
    partner: false,
    partnerName: ''
  }, {
    title: 'Clean water and sanitation',
    icon: 'fa fa-tint',
    image: 'http://spring.myrberginnovation.se/assets/img/development-goal-6.png',
    category: '',
    today: '',
    tomorrow: '',
    next: '',
    partner: false,
    partnerName: ''
  }, {
    title: 'Affordable and clean energy',
    icon: 'fa fa-sun-o',
    image: 'http://spring.myrberginnovation.se/assets/img/development-goal-7.png',
    category: '',
    today: '',
    tomorrow: '',
    next: '',
    partner: false,
    partnerName: ''
  }, {
    title: 'Decent work and economic growth',
    icon: 'fa fa-line-chart',
    image: 'http://spring.myrberginnovation.se/assets/img/development-goal-8.png',
    category: '',
    today: '',
    tomorrow: '',
    next: '',
    partner: false,
    partnerName: ''
  }, {
    title: 'Industry, innovation and infrastructure',
    icon: 'fa fa-industry',
    image: 'http://spring.myrberginnovation.se/assets/img/development-goal-9.png',
    category: '',
    today: '',
    tomorrow: '',
    next: '',
    partner: false,
    partnerName: ''
  }, {
    title: 'Reduced inequalities',
    icon: 'fa fa-genderless',
    image: 'http://spring.myrberginnovation.se/assets/img/development-goal-10.png',
    category: '',
    today: '',
    tomorrow: '',
    next: '',
    partner: false,
    partnerName: ''
  }, {
    title: 'Sustainable cities and communities',
    icon: 'fa fa-hospital-o',
    image: 'http://spring.myrberginnovation.se/assets/img/development-goal-11.png',
    category: '',
    today: '',
    tomorrow: '',
    next: '',
    partner: false,
    partnerName: ''
  }, {
    title: 'Responsible consumption and production',
    icon: 'fa fa-heart',
    image: 'http://spring.myrberginnovation.se/assets/img/development-goal-12.png',
    category: '',
    today: '',
    tomorrow: '',
    next: '',
    partner: false,
    partnerName: ''
  }, {
    title: 'Climate action',
    icon: 'fa fa-heart',
    image: 'http://spring.myrberginnovation.se/assets/img/development-goal-13.png',
    category: '',
    today: '',
    tomorrow: '',
    next: '',
    partner: false,
    partnerName: ''
  }, {
    title: 'Life below water',
    icon: 'fa fa-heart',
    image: 'http://spring.myrberginnovation.se/assets/img/development-goal-14.png',
    category: '',
    today: '',
    tomorrow: '',
    next: '',
    partner: false,
    partnerName: ''
  }, {
    title: 'Life on land',
    icon: 'fa fa-heart',
    image: 'http://spring.myrberginnovation.se/assets/img/development-goal-15.png',
    category: '',
    today: '',
    tomorrow: '',
    next: '',
    partner: false,
    partnerName: ''
  }, {
    title: 'Peace, justice and strong institutions',
    icon: 'fa fa-heart',
    image: 'http://spring.myrberginnovation.se/assets/img/development-goal-16.png',
    category: '',
    today: '',
    tomorrow: '',
    next: '',
    partner: false,
    partnerName: ''
  }, {
    title: 'Partnerships for goals',
    icon: 'fa fa-heart',
    image: 'http://spring.myrberginnovation.se/assets/img/development-goal-17.png',
    category: '',
    today: '',
    tomorrow: '',
    next: '',
    partner: false,
    partnerName: ''
  }
];



// WEBPACK FOOTER //
// /Users/Myrberg/Documents/spring_repo1/spring-app/src/app/base/components/canvas/components/sustainability-goals/goals/goals.ts